// Stub: Matilda's online/offline model registries.
// Creator3D uses these for the chat agent picker. With the chat disabled,
// these can stay empty without breaking the surface that references them.

export interface ModelMeta {
  id: string;
  name: string;
  provider?: string;
  requiresKey?: boolean;
}

export const ONLINE_MODELS: ModelMeta[] = [];
export const OFFLINE_MODELS: ModelMeta[] = [];
